import { bodiesOverlap } from '../geom'
import { moveFallingBody } from './body'
import { hit } from './hit'
import type { TrapItem } from './types'

/**
 * Oil Slick (PHASE3 T3.12): a flat trap dropped `dropBehindPx` behind the owner, like the Trip
 * Wire. The first player who runs onto it and can be hit skids instead of tumbling: no control
 * and `skidSpeedPct` of base speed for `skidTicks` (`hit(…, 'skid')`); a jump clears it. The
 * owner is ignored for `ownerGraceTicks`.
 */
export const oilSlick: TrapItem = {
  id: 'oil_slick',
  use(world, i) {
    const p = world.players[i]!
    const os = world.cfg.items.oilSlick
    world.traps.push({
      id: world.nextId++,
      kind: 'oil_slick',
      owner: i,
      x: p.x - os.dropBehindPx,
      y: p.y,
      w: os.widthPx,
      h: os.heightPx,
      vy: 0,
      grounded: p.grounded,
      ownerSafeUntil: world.tick + os.ownerGraceTicks,
      expiresAtTick: world.tick + os.lifetimeTicks,
    })
  },
  update(world, t, events) {
    if (world.tick >= t.expiresAtTick) return false
    moveFallingBody(world, t, 0)
    if (t.y > world.track.killY) return false
    const { skidTicks } = world.cfg.items.oilSlick
    for (let i = 0; i < world.players.length; i++) {
      if (i === t.owner && world.tick < t.ownerSafeUntil) continue
      if (!bodiesOverlap(world.players[i]!, t)) continue
      if (hit(world, i, 'oil_slick', skidTicks, events, t.owner, 'skid')) return false
    }
    return true
  },
}
